module.exports = __webpack_public_path__ + "static/media/menu-white.cafa37c8.svg";